import React from "react";
import MediaControl from "../../components/MediaControl/mediaControl.component";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

import { useStyles } from "../../components/Card/cardStyle.js";

function Player({ feed }) {
  const classes = useStyles();
  // const [addedFav, setAddedFav] = React.useState(false);

  return (
    <>
      <Card className={classes.root} elevation={0} variant="outlined">
        <a href={feed.url}>
          <CardHeader
            style={{
              contentAlign: "center",
              margin: "0 auto",
              fontSize: ".2rem",
            }}
            avatar={
              <Avatar aria-label="recipe" className={classes.avatar}>
                {feed.avatar}
              </Avatar>
            }
            title={feed.title}
            subheader={feed.date}
          />
        </a>
        {/* <CardMedia
          className={classes.media}
          image={feed.img}
          title={feed.image_title}
        /> */}
        <CardContent
          style={{
            backgroundImage: `linear-gradient( rgba(199, 199, 199, 0.7), rgba(0, 0, 0, 0.7) ), url(${feed.img})`,
            height: "100vh",
            width: "100%",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat, no-repeat",
            backgroundPosition: "cover",
            overflowY: "scroll",
            color: "white !important",
          }}
        >
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            style={{ color: "white", fontWeight: 600 }}
          >
            {feed.content}
          </Typography>
        </CardContent>

        {/* <CardActions disableSpacing>
          <IconButton
            onClick={() => setAddedFav(!addedFav)}
            aria-label="add to favorites"
          >
            {addedFav ? (
              <FavoriteIcon color="secondary" fontSize="small" />
            ) : (
              <FavoriteIcon fontSize="small" />
            )}
          </IconButton>
        </CardActions> */}

        {/* Double tap to like functionality */}
      </Card>
      <MediaControl text={feed.content} mediaUrl={feed.mediaSource}/>
    </>
  );
}

export default Player;
